import React from 'react'
import Slide from "./Slide";
import GenreSlide from './GenreSlide';
import SidePlaylistComponent from './SidePlaylistComponent';
import SlideWithVideo from './SlideWithVideo';

export default function Slides(props) {
    const sWRightSpaceClass = props.displayCount === 3 ? 'slide-wrapper-for-four' : 'slide-wrapper-for-six'

    return (
        <>
            { props.tvData && props.tvData.length ?
                props.tvData.map(
                    (data, i) =>
                        <div
                            onClick={() => props.slideClickHandler(data)}
                            className={'position-relative px-1 px-md-0 slide-wrapper ' + sWRightSpaceClass}
                            role='button'
                            key={i}
                            style={{
                                width: `${props.slideWrapperWidth}vw`,
                                height: '100%'
                            }}
                        >
                            {
                                props.type === 3?
                                <GenreSlide
                                    item = {data}
                                /> :
                                props.type === 4 ?
                                <SidePlaylistComponent
                                    video = {data}
                                /> :
                                props.type === 5 ?
                                <SlideWithVideo
                                    item = {data}
                                />
                                :
                                <Slide
                                    type = {props.type}
                                    tvData = {data}
                                    width =  {"100%"}
                                />
                            }

                        </div>
                )
                : ''
            }
        </>
    )
}
